import Vue from 'vue'
import Debounce from '@/directive/debounce'
import Throttle from '@/directive/throttle'
import Draggable from '@/directive/draggable'
import ClickOutside from '@/directive/clickOutside'

Vue.use(Throttle)
Vue.use(Debounce)
Vue.use(Draggable)
Vue.use(ClickOutside)
